module.exports = __webpack_public_path__ + "static/media/GE.b61c3434.svg";